
export const setActiveTopicAction = (id: string) => {
  return {
    type: 'SET_ACTIVE_TOPIC',
    data: { id: id },
  };
};
